module.exports = __webpack_public_path__ + "static/media/switchTitles.a96fdb6d.mp3";